import React, { memo } from 'react';

export default memo(({ children, condition, usedat }) => {
  return condition ? children : null;
});
